<template>
    <div :class="['info-notice', `info-notice--${variant}`]">
        <div class="info-notice__icon">
            <v-icon
                :color="iconColor"
                size="20"
            >
                {{ icon }}
            </v-icon>
        </div>
        <div class="info-notice__body">
            <div
                v-if="title || $slots.title"
                class="info-notice__title"
            >
                <slot name="title">{{ title }}</slot>
            </div>
            <div
                v-if="$slots.default || description"
                class="info-notice__desc"
            >
                <slot>{{ description }}</slot>
            </div>
        </div>
        <div
            v-if="$slots.actions"
            class="info-notice__actions"
        >
            <slot name="actions" />
        </div>
    </div>
</template>

<script>
export default {
    name: 'InfoNotice',
    props: {
        title: { type: String, default: '' },
        description: { type: String, default: '' },
        icon: { type: String, default: 'mdi-information-outline' },
        variant: {
            type: String,
            default: 'primary',
            validator: v => ['primary', 'success', 'warning', 'error', 'neutral'].includes(v),
        },
    },
    computed: {
        iconColor() {
            switch (this.variant) {
                case 'success': return 'success'
                case 'warning': return 'warning'
                case 'error': return 'error'
                case 'neutral': return 'on-surface-variant'
                default: return 'primary'
            }
        },
    },
}
</script>

<style scoped>
.info-notice {
    display: flex;
    align-items: flex-start;
    gap: 12px;
    padding: 16px;
    border-radius: var(--radius-sm);
    border: 1px solid rgba(112, 42, 225, 0.15);
    background: rgba(112, 42, 225, 0.04);
}

.info-notice--success {
    border-color: rgba(5, 150, 105, 0.2);
    background: rgba(5, 150, 105, 0.05);
}

.info-notice--warning {
    border-color: rgba(217, 119, 6, 0.2);
    background: rgba(217, 119, 6, 0.05);
}

.info-notice--error {
    border-color: rgba(180, 19, 64, 0.2);
    background: rgba(180, 19, 64, 0.05);
}

.info-notice--neutral {
    border-color: var(--glass-panel-border);
    background: var(--glass-soft-bg);
}

.info-notice__icon {
    flex-shrink: 0;
    padding-top: 2px;
}

.info-notice__body {
    flex: 1;
    min-width: 0;
}

.info-notice__title {
    font-family: var(--font-display);
    font-weight: 700;
    font-size: 0.875rem;
    color: var(--color-on-surface);
    margin-bottom: 2px;
}

.info-notice__desc {
    font-size: 0.8125rem;
    line-height: 1.5;
    color: var(--color-on-surface-variant);
}

.info-notice__actions {
    flex-shrink: 0;
    display: flex;
    align-items: center;
    gap: 8px;
}

@media (max-width: 599px) {
    .info-notice {
        display: grid;
        grid-template-columns: auto minmax(0, 1fr);
        column-gap: 12px;
        row-gap: 10px;
    }

    .info-notice__actions {
        grid-column: 2;
        min-width: 0;
        flex-wrap: wrap;
        justify-content: flex-start;
    }
}
</style>
